import { describeTestForTutor, isPublicTest, studentTestName } from '../../../session/testVisibility';

// `testList` (optional): session.test_list. A public test is "Example #N" to the student,
// who also sees its input and expected output, so it is named and described that way here;
// every other test keeps the plain "Test Case N" line.
export const formatTestResults = (testResults, testList = null) => {
    if (!testResults || testResults.length === 0) return "No test results available yet.";
    
    return testResults.map((passed, idx) => {
        const test = testList?.[idx];
        if (isPublicTest(test)) {
            return `${studentTestName(testList, idx)}: ${passed ? 'PASSED' : 'FAILED'} (${describeTestForTutor(test)})`;
        }
        return `Test Case ${idx + 1}: ${passed ? 'PASSED' : 'FAILED'}`;
    }).join('\n');
}; 